import(/* webpackMode: "eager" */ "/Users/ap/ama_dev/openint/repo/apps/web/app/global-error.tsx");
